var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M3,22H5V20H3Zm4,0H9V20H7ZM9,0H7V10H9Zm3.56,2.44L11.11,3.89a6,6,0,1,1-6.23,0L3.44,2.44a8,8,0,1,0,9.12,0ZM11,22h2V20H11Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }